<template>
  <!-- Container -->
  <div class="w-full max-w-full filterAnimation px-5" style="z-index: 5000000">
      <!-- New ads refresh button -->
      <NewAdvertisementButton v-if="getNewAds.length" @click="$emit('refresh')" />

    <!-- Main Bar -->
    <div class="flex items-center">
      <!-- Search Section -->
      <div v-if="noSearch" class="h-12"/>
      <div v-else class="search-input-container group py-1.5 px-2 my-2 flex flex-grow items-center transition rounded-md"
      style="min-width: 200px; max-width: 250px">
        <!-- Search Image -->
        <div class="w-5 h-5">
          <SearchIcon class="transition-colors ease-in-out"
          :class="searchFocused ? 'text-icon-normal' : 'text-text-subdued group-hover:text-icon-muted'"/>
        </div>
        <!-- Text Input -->
        <input ref="searchInput" :value="textSearch" placeholder="Search..." 
        @input="emitUpdate({ emitString: 'update:textSearch', items: $event.target.value, })"
        @focus="searchFocused = true" @blur="searchFocused = false"
        class="ml-1 text-sm rounded flex items-center outline-none transition-all border-none w-full 
        focus:border-none text-gray-500 bg-white bg-opacity-0">
      </div>
      <div v-if="!noSearch" class="flex flex-col mx-3">
        <div class="h-6 my-auto w-0 border-r border-border-normal" />
      </div>
      <!-- Filters -->
      <div class="h-full flex flex-grow justify-between items-center">
        <FilterList
          ref="filterList"
          :boardItems="getBoards"
          :brandItems="brands"
          :tagItems="getTags"
          :languageItems="languages"
          :nicheItems="niches"
          :selected-formats="selectedFormats"
          :selected-boards="selectedBoards"
          :selected-platforms="selectedPlatforms"
          :selected-content-filters="selectedContentFilters"
          :selected-market-targets="selectedMarketTargets"
          :selected-brands="selectedBrands"
          :selected-tags="selectedTags"
          :selected-languages="selectedLanguages"
          :selected-statuses="liveStatus"
          :selected-niches="selectedNiches"
          :excluded-filter-types="excludedFilterTypes"
          @update:selected-formats="emitUpdate({ emitString: 'update:selectedFormats', items: $event })"
          @update:selected-boards="emitUpdate({ emitString: 'update:selectedBoards', items: $event })"
          @update:selected-platforms="emitUpdate({ emitString: 'update:selectedPlatforms', items: $event })"
          @update:selected-brands="emitUpdate({ emitString: 'update:selectedBrands', items: $event })"
          @update:selected-tags="emitUpdate({ emitString: 'update:selectedTags', items: $event })"
          @update:selected-languages="emitUpdate({ emitString: 'update:selectedLanguages', items: $event })"
          @update:selected-statuses="emitUpdate({ emitString: 'update:liveStatus', items: $event })"
          @update:selected-niches="emitUpdate({ emitString: 'update:selectedNiches', items: $event })"
          @update:selected-content-filters="emitUpdate({ emitString: 'update:selectedContentFilters', items: $event })"
          @update:selected-market-targets="emitUpdate({ emitString: 'update:selectedMarketTargets', items: $event })"
        />

        <!-- Right Side -->
        <div class="flex items-center gap-1.5 justify-end h-full" :class="noSearch ? '' : 'ml-auto'">

          <!-- Show only Favorite (brands) -->
          <div v-if="typeof favoriteFilter === 'boolean'"
          class="dropdown-button flex items-center gap-0.5 pl-2 pr-2.5 rounded-md cursor-pointer" 
          :class="favoriteFilter ? 'expanded py-1' : 'py-1.5'"
          @click="() => emitUpdate({ emitString: 'update:favoriteFilter', items: !favoriteFilter })">
            <FavoriteIcon :active="favoriteFilter" noHover class="text-icon-normal" />
            <BaseText type="label" size="sm" class="text-text-muted no-select">
              Favorites
            </BaseText>
          </div>

          <!-- CSV button -->
          <!-- ARE WE STILL USING THIS? -->
          <!-- <BaseButton v-if="csvExport" outlined class="flex items-center justify-center w-max h-8 rounded-full transition duration-300">
            <div class="flex items-center justify-center gap-1 -my-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" class="opacity-70 h-6" fill="none">
                <path d="M11.1333 2.77984L11.5753 2.3379L11.5753 2.3379L11.1333 2.77984ZM15.5737 7.2202L16.0156 6.77826H16.0156L15.5737 7.2202ZM7.31185 18.3334C7.65703 18.3334 7.93685 18.0535 7.93685 17.7084C7.93685 17.3632 7.65703 17.0834 7.31185 17.0834V18.3334ZM12.7285 17.0834C12.3833 17.0834 12.1035 17.3632 12.1035 17.7084C12.1035 18.0535 12.3833 18.3334 12.7285 18.3334V17.0834ZM10.6452 11.4584C10.6452 11.1132 10.3654 10.8334 10.0202 10.8334C9.675 10.8334 9.39518 11.1132 9.39518 11.4584H10.6452ZM10.0202 16.6667L9.57824 17.1086C9.82232 17.3527 10.218 17.3527 10.4621 17.1086L10.0202 16.6667ZM12.5455 15.0253C12.7895 14.7812 12.7895 14.3855 12.5455 14.1414C12.3014 13.8973 11.9057 13.8973 11.6616 14.1414L12.5455 15.0253ZM8.37879 14.1414C8.13471 13.8973 7.73898 13.8973 7.49491 14.1414C7.25083 14.3855 7.25083 14.7812 7.49491 15.0253L8.37879 14.1414ZM5.64518 2.91669H9.95483V1.66669H5.64518V2.91669ZM15.4368 8.39871V16.0417H16.6868V8.39871H15.4368ZM10.6914 3.22178L15.1318 7.66214L16.0156 6.77826L11.5753 2.3379L10.6914 3.22178ZM4.60352 16.0417V3.95835H3.35352V16.0417H4.60352ZM7.31185 17.0834H5.64518V18.3334H7.31185V17.0834ZM14.3952 17.0834H12.7285V18.3334H14.3952V17.0834ZM3.35352 16.0417C3.35352 17.3073 4.37953 18.3334 5.64518 18.3334V17.0834C5.06989 17.0834 4.60352 16.617 4.60352 16.0417H3.35352ZM16.6868 8.39871C16.6868 7.79092 16.4454 7.20803 16.0156 6.77826L15.1318 7.66214C15.3271 7.85749 15.4368 8.12244 15.4368 8.39871H16.6868ZM9.95483 2.91669C10.2311 2.91669 10.496 3.02643 10.6914 3.22178L11.5753 2.3379C11.1455 1.90813 10.5626 1.66669 9.95483 1.66669V2.91669ZM15.4368 16.0417C15.4368 16.617 14.9705 17.0834 14.3952 17.0834V18.3334C15.6608 18.3334 16.6868 17.3073 16.6868 16.0417H15.4368ZM5.64518 1.66669C4.37953 1.66669 3.35352 2.6927 3.35352 3.95835H4.60352C4.60352 3.38306 5.06989 2.91669 5.64518 2.91669V1.66669ZM10.0202 2.70835V6.04169H11.2702V2.70835H10.0202ZM12.3118 8.33335H15.6452V7.08335H12.3118V8.33335ZM10.0202 6.04169C10.0202 7.30734 11.0462 8.33335 12.3118 8.33335V7.08335C11.7366 7.08335 11.2702 6.61698 11.2702 6.04169H10.0202ZM9.39518 11.4584V16.6667H10.6452V11.4584H9.39518ZM10.4621 17.1086L12.5455 15.0253L11.6616 14.1414L9.57824 16.2247L10.4621 17.1086ZM10.4621 16.2247L8.37879 14.1414L7.49491 15.0253L9.57824 17.1086L10.4621 16.2247Z"
                fill="#5E6678"/>
              </svg>
              <BaseText type="body" size="sm" class="text-text-muted">
                CSV
              </BaseText>
            </div>
          </BaseButton> -->

          <!-- Date Range Selector -->
          <div v-if="selectedDateRange" class="relative" 
          v-on-clickaway="() => { if (selectorExpanded.date) setSelectorExpanded('date', false) }">
            <div class="dropdown-button flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-md cursor-pointer"
            @click="setSelectorExpanded('date', !selectorExpanded.date)" :class="{'expanded': selectorExpanded.date}">
              <CalendarIcon class="text-icon-normal" />
              <BaseText type="label" size="sm" class="text-text-muted no-select">
                {{ dateFilterLabel }}
              </BaseText>
            </div>
            <transition>
              <div v-if="selectorExpanded.date" class="date-selector-dropdown">
                <DateRangeSelectorDropdown 
                  :selectedDateRange="getSelectedDateRange"
                  :dateFilterLabel.sync="dateFilterLabel"
                  @update:selectedDateRange="handleDateChange"
                  @close="setSelectorExpanded('date', false)"
                />
              </div>
            </transition>
          </div>

          <!-- Sort Order Dropdown Selector -->
          <div v-if="$route.name !== 'DiscoveryBrandsView'" class="relative" v-on-clickaway="() => { if (selectorExpanded.sort) setSelectorExpanded('sort', false) }">
            <div class="dropdown-button flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-md cursor-pointer"
            @click="setSelectorExpanded('sort', !selectorExpanded.sort)" :class="{'expanded': selectorExpanded.sort}">
              <SortIcon class="text-icon-normal" />
              <BaseText type="label" size="sm" class="text-text-muted no-select">
                {{ sortOrder[0]?.name || 'Newest' }}
              </BaseText>
            </div>
            <transition>
              <div v-if="selectorExpanded.sort" class="sort-selector-dropdown flex flex-col gap-0.5 p-1 rounded-lg bg-white">
                <div v-for="(sortItem, index) in sortValues" :key="`sort-item-${index}`" 
                class="dropdown-item" :class="{'selected': sortItem.value === sortOrder[0].value}"
                @click="emitUpdate({emitString: 'update:sortOrder', items: [sortItem]})">
                  <BaseText type="body" size="sm" class="text-text-normal">
                    {{ sortItem.name }}
                  </BaseText>
                  <div v-if="sortItem.value === sortOrder[0].value" class="ml-auto text-icon-normal">
                    <NewCheckmarkIcon class="text-icon-normal" />
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- Visible Dropdown Selector -->
          <div v-if="!(typeof favoriteFilter === 'boolean') && !hideAdSettings" class="relative"
          v-on-clickaway="() => { if (selectorExpanded.visible) setSelectorExpanded('visible', false) }">
            <div class="dropdown-button flex pl-2 pr-1 py-1.5 rounded-md cursor-pointer"
            @click="setSelectorExpanded('visible', !selectorExpanded.visible)" :class="{'expanded': selectorExpanded.visible}">
              <SetVisibleIcon class="text-icon-normal" />
              <div class="transform transition-transform duration-200" :style="selectorExpanded.visible ? 'transform: scale(1, -1)' : ''">
                <ChevronIcon />
              </div>
            </div>
            <transition>
              <div v-if="selectorExpanded.visible" class="visible-selector-dropdown flex flex-col gap-0.5 p-1 rounded-lg bg-white">
                <div v-for="(setting, index) in ['Brand Details', 'Ad Copy', 'Headline & CTA']" :key="`visible-setting-${index}`"
                class="dropdown-item group" @click="toggleVisibleSetting(setting)">
                  <BaseText type="body" size="sm" class="text-text-normal transition-colors group-hover:text-black">
                    {{ setting }}
                  </BaseText>
                  <div class="ml-auto">
                    <BaseToggle :value="adSettings.some(s => s.value === setting)" :color="`primary-${getTheme}-100`" />
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- View Dropdown Selector -->
          <div v-if="selectedView" class="relative" v-on-clickaway="() => { if (selectorExpanded.view) setSelectorExpanded('view', false) }">
            <div class="dropdown-button flex pl-2 pr-1 py-1.5 rounded-md cursor-pointer"
            @click="setSelectorExpanded('view', !selectorExpanded.view)" :class="{'expanded': selectorExpanded.view}">
              <GridViewIcon v-if="selectedView === 'grid'" class="text-icon-normal" />
              <TableViewIcon v-else-if="selectedView === 'table'" class="text-icon-normal" />
              <GanttViewIcon v-else class="text-icon-normal" />
              <div class="transform transition-transform duration-200" :style="selectorExpanded.view ? 'transform: scale(1, -1)' : ''">
                <ChevronIcon />
              </div>
            </div>
            <transition>
              <div v-if="selectorExpanded.view" class="view-selector-dropdown flex flex-col gap-0.5 p-1 rounded-lg bg-white no-select"
              :style="{width: viewOptions.some((view) => view.value === 'gantt') ? '175px' : '156px'}">
                <div class="dropdown-item group" :class="{'selected': selectedView === 'grid'}"
                @click="setSelectorExpanded('view', false), $emit('update:selectedView', 'grid')">
                  <GridViewIcon class="text-icon-normal" />
                  <BaseText type="body" size="sm" class="transition-colors text-text-normal group-hover:text-black">
                    Grid View
                  </BaseText>
                  <div v-if="selectedView === 'grid'" class="ml-auto text-icon-normal">
                    <NewCheckmarkIcon />
                  </div>
                </div>
                <div v-if="viewOptions.some((view) => view.value === 'table')" class="dropdown-item group" :class="{'selected': selectedView === 'table'}"
                @click="setSelectorExpanded('view', false), $emit('update:selectedView', 'table')">
                  <TableViewIcon class="text-icon-normal" />
                  <BaseText type="body" size="sm" class="transition-colors text-text-normal group-hover:text-black">
                    List View
                  </BaseText>
                  <div v-if="selectedView === 'table'" class="ml-auto text-icon-normal">
                    <NewCheckmarkIcon />
                  </div>
                </div>
                <div v-if="viewOptions.some((view) => view.value === 'gantt')" class="dropdown-item group" :class="{'selected': selectedView === 'gantt'}"
                @click="setSelectorExpanded('view', false), $emit('update:selectedView', 'gantt')">
                  <GanttViewIcon class="text-icon-normal" />
                  <BaseText type="body" size="sm" class="transition-colors text-text-normal group-hover:text-black">
                    Timeline View
                  </BaseText>
                  <div v-if="selectedView === 'gantt'" class="ml-auto text-icon-normal">
                    <NewCheckmarkIcon />
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway2'
import firebase from '../../api/config/FirebaseConfig'
import FavoriteIcon from '../globals/Icons/FavoriteIcon.vue'
import TagIcon from '../globals/Icons/TagIcon.vue'
import SearchIcon from '../globals/Icons/SearchIcon.vue'
import ChevronIcon from '../globals/Icons/ChevronIcon.vue'
import NewCheckmarkIcon from '../globals/Icons/NewCheckmarkIcon.vue'
import SortIcon from '../globals/Icons/SortIcon.vue'
import CalendarIcon from '../globals/Icons/CalendarIcon.vue'
import SetVisibleIcon from '../globals/Icons/SetVisibleIcon.vue'
import * as ViewIcons from '../globals/Icons/ViewTypeIcons'
import FilterList from './TopBarComponents/FilterList.vue'
import DateRangeSelectorDropdown from './TopBarComponents/DateRangeSelectorDropdown.vue'
import NewAdvertisementButton from '../../components/advertisements/NewAdvertisementButton.vue'
import { sendEventSocket } from '@/api/sockets'

export default {
  name: 'FilterTopBar',
  mixins: [clickaway],
  components: {
    FilterList,
    DateRangeSelectorDropdown,
    FavoriteIcon,
    TagIcon,
    SearchIcon,
    ChevronIcon,
    NewAdvertisementButton,
    NewCheckmarkIcon,
    SortIcon,
    CalendarIcon,
    SetVisibleIcon,
    ...ViewIcons
  },
  props: {
    keywordSearchOpened: {
      type: Boolean,
      default: false
    },
    selectedFormats: {
      type: Array,
      default: () => null
    },
    selectedBoards: {
      type: Array,
      default: () => null
    },
    selectedNiches: {
      type: Array,
      default: () => null
    },
    selectedContentFilters: {
      type: Array,
      default: () => null
    },
    selectedPlatforms: {
      type: Array,
      default: () => null
    },
    selectedBrands: {
      type: Array,
      default: () => null
    },
    selectedTags: {
      type: Array,
      default: () => null
    },
    selectedLanguages: {
      type: Array,
      default: () => null
    },
    selectedMarketTargets: {
      type: Array,
      default: () => null
    },
    liveStatus: {
      type: Array,
      default: () => null
    },
    textSearch: {
      type: String,
      default: () => ''
    },
    favoriteFilter: {
      type: Boolean,
      default: () => null
    },
    noSearch: {
      type: Boolean,
      default: () => false
    },
    discoveryBrands: {
      type: Boolean,
      default: () => false
    },
    alphabetical: {
      type: Boolean,
      default: () => false
    },
    sortOrder: {
      type: Array,
      default: () => []
    },
    hideAdSettings: {
      type: Boolean,
      default: () => false
    },
    csvExport: {
      type: Boolean,
      default: () => false
    },
    externalFilters: {
      type: Array,
      default: () => []
    },
    selectedView: {
      type: String,
      default: () => null
    },
    viewOptions: {
      type: Array,
      default: () => [
        { name: 'Grid', value: 'grid' },
        { name: 'Table', value: 'table' }
      ]
    },
    selectedDateRange: {
      type: Object,
      default: () => {}
    },
    excludedFilterTypes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      niches: [],
      brands: [],
      languages: [],
      focused: null,
      timer: null,
      facebookImage: require('../../assets/images/facebook-library.png'),
      instagramImage: require('../../assets/images/instagram-small.png'),
      tiktokImage: require('../../assets/images/tiktok-organic.png'),
      loadingBrands: true,
      adSettings: [],
      loadingSave: false,
      currentUser: {},
      additionalFilters: 0,
      searchFocused: false,
      dateFilterLabel: 'All Time',
      sortLabel: 'Newest',
      selectorExpanded: {
        view: false,
        sort: false,
        visible: false,
        date: false
      },
      eventIntervalId: null
    }
  },
  computed: {
    ...mapGetters('BoardsModule', ['getBoards']),
    ...mapGetters('AuthModule', ['getUser', 'getTeam']),
    ...mapGetters('TagsModule', ['getTags']),
    ...mapGetters('MiscModule', ['getTheme']),
    ...mapGetters('AdvertisementsModule', ['getNewAds']),
    getSelectedDateRange () {
      this.changeAdditionalFilters()
      return this.selectedDateRange
    },
    filtersApplied () {
      return (
        this.selectedPlatforms?.length ||
        this.selectedTags?.length ||
        this.selectedFormats?.length ||
        this.selectedBoards?.length ||
        this.selectedNiches?.length ||
        this.selectedContentFilters?.length ||
        this.selectedLanguages?.length ||
        this.selectedBrands?.length ||
        this.liveStatus?.length ||
        this.textSearch?.length ||
        this.favoriteFilter
      )
    },
    sortValues () {
      const alphabeticalSort = [
        { name: 'A-Z', value: 'asc' },
        { name: 'Z-A', value: 'desc' }
      ]
      if (this.discoveryBrands) {
        alphabeticalSort.push({
          name: 'Ads Saved',
          value: 'saved'
        })
      }

      const adsSort = [
        { name: 'Newest', value: 'desc' },
        { name: 'Oldest', value: 'asc' },
        { name: 'Longest Running', value: 'longest' },
      ]
      if (this.textSearch?.length) {
        adsSort.unshift({ name: 'Most Relevant', value: 'relevance' })
      }

      return this.alphabetical ? alphabeticalSort : adsSort
    }
  },
  watch: {
    'selectedDateRange.start': function () {
      this.changeAdditionalFilters()
    },
    'selectedDateRange.end': function () {
      this.changeAdditionalFilters()
    },
    keywordSearchOpened (newVal) {
      this.searchFocused = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
          this.$emit('resetKeywordSearch')
        })
      }
    }
  },
  mounted () {
    this.getNiches()
    this.fetchTags()
    if (this.selectedLanguages) {
      this.getLanguages()
    }
    if (this.selectedBrands) {
      this.getUserBrands()
    }
    this.currentUser = {
      ...this.getUser,
      first_name: this.getUser.first_name || this.getUser.name
    }
    this.adSettings = this.currentUser.adSettings || [
      { name: 'Brand Details', value: 'Brand Details' }
    ]
  },
  methods: {
    ...mapActions('TagsModule', ['fetchTags']),
    ...mapMutations('AuthModule', ['SET_USER']),
    ...mapMutations('SearchModule', ['SET_CURRENT_TEXT_SEARCH', 'SET_CURRENT_FILTERS']),
    handleDateChange (date) {
      console.log(date)
      this.$emit('update:selectedDateRange', date)
      this.$emit('change')
    },
    changeAdditionalFilters () {
      this.additionalFilters = (this.selectedDateRange?.start === null && this.selectedDateRange?.end === null) ? 0 : 1
    },
    unFocus (toUnfocus) {
      if (toUnfocus === this.focused) {
        this.focused = null
        this.$emit('resetKeywordSearch')
      }
    },
    setSelectorExpanded (dropdown, isExpanded) {
      // Toggle the specified dropdown, close all others
      this.selectorExpanded[dropdown] = isExpanded
      Object.keys(this.selectorExpanded).forEach((key) => {
        if (key !== dropdown) {
          this.selectorExpanded[key] = false
        }
      })
    },
    toggleVisibleSetting (setting) {
      if (this.adSettings.some((s) => s.value === setting)) {
        this.adSettings = this.adSettings.filter((s) => s.value !== setting)
      } else {
        this.adSettings = [...this.adSettings, { name: setting, value: setting }]
      }
      this.updateAdSettings(this.adSettings)
    },
    async updateAdSettings (settings) {
      try {
        const db = firebase.firestore()
        delete this.currentUser.token
        this.currentUser.adSettings = settings

        await db.collection('auth-users').doc(this.currentUser.user_id).update({
          adSettings: settings
        })
        this.SET_USER({
          ...this.getUser,
          ...this.currentUser,
          token: this.getUser.uid
        })
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
        }, 100)
      } catch (err) {
        console.log(err)
      } finally {
        this.loadingSave = false
      }
    },
    emitUpdate (emitObject) {
      const { emitString, items } = emitObject

      // Update Search State with the proper items
      this.SET_CURRENT_TEXT_SEARCH(this.textSearch)

      const filterUpdatePayload = {
        publisher_platform: this.selectedPlatforms,
        formats: this.selectedFormats,
        niches: this.selectedNiches,
        contentFilters: this.selectedContentFilters,
        marketTarget: this.selectedMarketTargets,
        languages: this.selectedLanguages || [],
        liveStatus: this.liveStatus,
        textSearch: this.textSearch,
        favoriteFilter: this.favoriteFilter || false
      }

      // Map the emit string to the correct payload key
      const keyMap = {
        selectedPlatforms: 'publisher_platform',
        selectedFormats: 'formats',
        selectedNiches: 'niches',
        selectedContentFilters: 'contentFilters',
        selectedMarketTargets: 'marketTarget',
        selectedLanguages: 'languages',
        liveStatus: 'liveStatus',
        textSearch: 'textSearch',
        favoriteFilter: 'favoriteFilter'
      }

      const updateField = emitString.split(':')[1]
      const payloadKey = keyMap[updateField] || updateField
      filterUpdatePayload[payloadKey] = items

      this.SET_CURRENT_FILTERS(filterUpdatePayload)

      // Clear existing timeout and set new one
      if (this.eventIntervalId) {
        clearTimeout(this.eventIntervalId)
      }

      this.eventIntervalId = setTimeout(() => {
        sendEventSocket('search')
      }, 400)

      if (emitString === 'update:textSearch') {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        this.timer = setTimeout(async () => {
          if (this.textSearch === '') {
            this.$emit('update:sortOrder', [
              {
                name: 'Most Relevant',
                value: 'relevance',
                disabled: false
              }
            ])
          } else if (items === '') {
            this.$emit('update:sortOrder', [{ name: 'Newest', value: 'desc' }])
          }
          // Track event if user searched
          window.analytics.track('User Searched Ai', {
            searchQuery: this.textSearch
          })

          this.$emit(emitString, items)
          this.$emit('change')
        }, 1000)
      } else {
        console.log('Emitting the following event: ', emitString, items)
        this.$emit(emitString, items)
        this.$emit('change')
      }
    },
    async getUserBrands () {
      this.brands = []

      try {
        const db = firebase.firestore()
        const { uid } = firebase.auth().currentUser

        const createdCondition = this.getTeam
          ? ['teamId', '==', this.getTeam.id]
          : ['createdBy', '==', uid]

        const query = await db
          .collection('user-brands')
          .where(...createdCondition)
          .orderBy('name', 'asc')
        // Setup
        const snapshot = await query.get()

        const { size } = snapshot
        this.lastDocId = size ? snapshot.docs[size - 1].id : null

        const newDocs = snapshot.docs?.map((doc) => {
          return {
            id: doc.id,
            ...(doc.data() || [])
          }
        })

        this.brands = newDocs
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingBrands = false
        this.infiniteId += 1
      }

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 600)
    },
    async getLanguages () {
      // Setup
      const db = firebase.firestore()

      const snapshot = await db.collection('languages').get()

      const newDocs = snapshot.docs?.map((doc) => {
        const docData = {
          ...(doc.data() || [])
        }

        return { name: docData.language }
      })

      const sortedDocs = newDocs.sort((a, b) => (a.name > b.name ? 1 : -1))
      this.languages = sortedDocs
    },
    async getNiches () {
      // Setup
      const db = firebase.firestore()

      const snapshot = await db.collection('niches').get()

      const newDocs = snapshot.docs?.map((doc) => {
        const docData = {
          ...(doc.data() || [])
        }

        return { name: docData.niche, icon: docData.emoji }
      })

      const sortedDocs = newDocs.sort((a, b) => (a.name > b.name ? 1 : -1))
      const otherIndex = sortedDocs.findIndex((d) => d.name === 'Other')
      const otherNiche = sortedDocs.splice(otherIndex, 1)

      sortedDocs.push(otherNiche[0])

      this.niches = sortedDocs
    },
    clearAllFilters () {
      // Called directly from parent
      const filterList = this.$refs.filterList
      filterList.clearFilters()
    }
  }
}
</script>

<style scoped lang="css">
  .filterAnimation {
    animation: fade 500ms ease-in-out;
  }
  .search-input-container {
    --placeholder-color: #5E6678;
    transition: box-shadow 150ms ease-in-out, background-color 150ms ease-in-out;
    background-color: transparent;
    box-shadow: none;
  }
  .search-input-container:hover {
    box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
    background-color: white;
    --placeholder-color: black;
  }
  .search-input-container:focus-within {
    box-shadow: none;
    background-color: transparent;
    --placeholder-color: #A4ACB9;
  }
  .search-input-container input::placeholder {
    transition: color 150ms ease-in-out;
    color: var(--placeholder-color);
  }
  .dropdown-button {
    transition: box-shadow 150ms ease-in-out, background-color 150ms ease-in-out;
    background-color: transparent;
    box-shadow: none;
    white-space: nowrap;
  }
  .dropdown-button:hover {
    box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
    background-color: white;
  }
  .dropdown-button.expanded {
    box-shadow: none;
    background-color: #F6F8FA;
  }
  .visible-selector-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 195px;
    box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
    z-index: 500;
  }
  .view-selector-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
    z-index: 500;
  }
  .sort-selector-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 170px;
    box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13), 0px 0px 0px 1px rgba(0, 56, 108, 0.08);
    z-index: 500;
  }
  .date-selector-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    z-index: 500;
  }
  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.375rem 0.5rem;
    border-radius: 0.375rem;
    transition: background-color 150ms ease-in-out;
    cursor: pointer;
  }
  .dropdown-item:hover, .dropdown-item.selected {
    background-color: #F8FAFB;
  }

  .v-enter-active, .v-leave-active {
    transition: opacity 150ms ease-in-out;
  }
  .v-enter-from, .v-enter, .v-leave-to {
    opacity: 0;
  }
  .v-enter-to, .v-leave-from {
    opacity: 1;
  }

  /* class is applied to elements we don't want users to be able to select text on */
  .no-select {
  -webkit-user-select: none; /* Safari */        
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  }
</style>

<style scoped>
div.vc-container {
  border: 0px !important;
}
</style>
